import { render, staticRenderFns } from "./StepNotes.vue?vue&type=template&id=3a157f94&"
import script from "./StepNotes.vue?vue&type=script&lang=js&"
export * from "./StepNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports